module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "share-qrcode"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "bottom-code"
  }, [_c('xk-qr-code', {
    attrs: {
      "val": _vm.url
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("扫码分享，即刻下单")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "QrCode"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/qr_bg.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b9e2a92","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/qrCode/qrCode.vue
// module id = 527
// module chunks = 0